import React from "react";
import { Outlet } from "react-router-dom";

const PublicLayout = () => {
  return (
    <div className="h-[100dvh] bg-slate-100 overflow-hidden overscroll-none">
      <main className="h-full overflow-auto overscroll-contain">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;
